module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("Program Status Conditions")]), _vm._v(" "), _c('form', {
    attrs: {
      "data-vv-scope": "program_status_condition_form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Program Status Field")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    domProps: {
      "value": _vm.value.field
    },
    on: {
      "input": function($event) {
        return _vm.updateField($event.target.value)
      }
    }
  }, _vm._l((_vm.schema), function(field) {
    return (['radio-group', 'select'].includes(field.type)) ? _c('option', {
      domProps: {
        "value": field.name
      }
    }, [_vm._v(_vm._s(field.description) + "\n        ")]) : _vm._e()
  }), 0), _vm._v(" "), (_vm.programStatusConditionField) ? _c('ul', {
    staticClass: "list-group program-status-conditions-list"
  }, _vm._l((_vm.programStatusConditionField.values), function(option, idx) {
    return _c('li', {
      staticClass: "list-group-item",
      class: {
        'has-error': _vm.errors.has('program_status_condition_form.programStatusCondition' + idx)
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('label', [_vm._v("Label")]), _vm._v(" "), _c('input', {
      staticClass: "form-control",
      attrs: {
        "id": 'ps-condition-' + idx,
        "name": "Form Name",
        "type": "text",
        "disabled": true
      },
      domProps: {
        "value": option.label
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.value.conditions[option.label]),
        expression: "value.conditions[option.label]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required|integer'),
        expression: "'required|integer'"
      }],
      staticClass: "form-control",
      attrs: {
        "name": 'programStatusCondition' + idx,
        "data-vv-as": 'status for ' + option.label
      },
      on: {
        "input": function($event) {
          return _vm.$emit('input', _vm.value)
        },
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.value.conditions, option.label, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 1
      }
    }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("Dismissed")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('program_status_condition_form.programStatusCondition' + idx)),
        expression: "errors.has('program_status_condition_form.programStatusCondition'+idx)"
      }],
      staticClass: "help-block red"
    }, [_vm._v("The Program Status is required.")])])])])
  }), 0) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f99848e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/VueProgramStatusConditions.vue
// module id = 1763
// module chunks = 1